// extracted by mini-css-extract-plugin
export default {"suggestion":"suggestion__3LvTBk7Y4j8DXihCFtrMN2"};